// code generated by `script:genMeta` - DO NOT EDIT
export const version = 'v4.6.0';
export const versionCode = 'Krile Baldesion';
export const date = 1789609432333;
